/**
 * Copyright (c) Aleksei Volkov and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import moment from 'moment/moment'
import './App.css'
import { Route, Switch } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import SignIn from 'pages/SignIn/SignIn'
import NoMatch from 'pages/NoMatch/NoMatch'
import 'moment/locale/ru'
import React from 'react'
import { mobileRoutes } from 'routes/mobileRoutes'
import { desktopRoutes } from 'routes/desktopRoutes'
import PrivateRoute from 'routes/PrivateRoute'
import { withAuthStore } from 'context/AuthStore'

const isMobile = window.innerWidth <= 768
function App({ authStore, ...props }) {
  moment.locale('ru')
  const routes = isMobile
    ? mobileRoutes(authStore.user.role)
    : desktopRoutes(authStore.user.role)

  return (
    <Switch>
      {routes.map(route => (
        <PrivateRoute {...route} key={route.path} />
      ))}
      <Route path={SIGN_IN_PATH} render={props => <SignIn {...props} />} />
      {/*      <Route path={'/'} render={() => <Redirect to={redirect()} />} />*/}
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  )
}

export default withAuthStore(App)
